import React from 'react'
import { ISessionAPI } from '../types'

const SessionAPIContext = React.createContext<ISessionAPI>(null)
export default SessionAPIContext
